import { replacePlaceholdersInRichText } from '@widget/utils/placeholders';

import type { MarketTrends } from '@widget/core';
import type { Richtext } from 'storyblok-js-client';

const DEFAULT_VALUATION_COUNT = 86;
const MINIMUM_THRESHOLD = 50;

export function replaceVariablesInSocialProof(message: Richtext, marketTrends?: MarketTrends) {
  if (!marketTrends) {
    return message;
  }

  return replacePlaceholdersInRichText(message, {
    valuationCount:
      marketTrends.shortValuationMr > MINIMUM_THRESHOLD
        ? marketTrends.shortValuationMr
        : DEFAULT_VALUATION_COUNT,
  });
}
